<a [href]="cleanUrl(url)" target="_blank">
    <ng-content></ng-content>
</a>